import React, { createContext, useContext, useState } from "react";

const SaleContext = createContext();

export const SaleProvider = ({ children }) => {
  const [isSaleData, setSaleData] = useState([]);
  const [paymentModal, setPaymentModal] = useState(false);
  const [isSaleModalOpen, setSaleModalOpen] = useState(false);
  const [optData, setOptData] = useState({
    isCustomerDisplay: true,
    isRemark: false,
    isPayment: true,
    isSupplier: true,
    isBankDetails: false,
    withTax: true,
  });
  return (
    <SaleContext.Provider value={{ isSaleData, setSaleData,paymentModal,setPaymentModal ,isSaleModalOpen, setSaleModalOpen, optData,
        setOptData,}}>
      {children}
    </SaleContext.Provider>
  );
};

export const useSaleContext = () => {
  return useContext(SaleContext);
};